import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  connect() {
  }

  copyInvoiceNumber() {
    const copyText = document.getElementById("newInvoiceNumber");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    copyText.value = "";
  }

  updateBankAccount(event) {
    event.preventDefault();

    const form = this.element.closest("form");
    if (!form) {
      console.error("Form not found");
      return;
    }

    const spinner = document.getElementById("checkbox-loader");
    if (spinner) spinner.classList.remove("d-none");

    const select = event.target;
    const cashPaymentId = form.getAttribute("action").split("/").slice(-2, -1)[0];
    const link = `/admin/cash_payments/${cashPaymentId}/update_cash_pdf_bank_account`;

    const formData = new FormData(form);
    formData.append("cash_payment[bank_account]", select.value);

    Rails.ajax({
      type: "POST",
      url: link,
      data: formData,
      success: () => {
        if (spinner) spinner.classList.add("d-none");
      },
      error: (err) => {
        console.error("Error updating bank account", err);
        if (spinner) spinner.classList.add("d-none");
      }
    });
  }
}
